import { HStack, IconButton, Input, Tooltip } from '@chakra-ui/react';
import { useState } from 'react';
import { IoCheckmark, IoPencil } from 'react-icons/io5';
import useCurrencyFormatter from '../hooks/useCurrencyFormatter';

type Props = {
  isEditable: boolean;
  amount: number;
  partialAmount?: number;
  onChange: (partialAmount?: number) => void;
  children: React.ReactNode;
};

const EditableAmount = ({ isEditable, amount, partialAmount, onChange, children }: Props): JSX.Element => {
  const [isEditing, setIsEditing] = useState(false);
  const [value, setValue] = useState('');
  const formatCurrency = useCurrencyFormatter();
  const isInvalid = !!value && Number(value) !== amount && Number(value) < 3000;

  const confirm = () => {
    if (isInvalid) return;
    const newAmount = Number(value);
    onChange(newAmount && newAmount !== amount ? newAmount : undefined);
    setIsEditing(false);
  };

  if (!isEditable) return <>{children}</>;

  if (!isEditing)
    return (
      <HStack spacing={1} display={'inline-flex'}>
        {children}
        <IconButton
          aria-label="Editar valor a pagar"
          icon={<IoPencil />}
          size="xs"
          variant="ghost"
          onClick={(e) => {
            e.stopPropagation();
            setValue(String(partialAmount ?? amount));
            setIsEditing(true);
          }}
        />
      </HStack>
    );

  return (
    <HStack spacing={1} display={'inline-flex'} onClick={(e) => e.stopPropagation()}>
      <Tooltip
        hasArrow
        isOpen={isInvalid}
        label="Monto inválido"
        placement="bottom-start"
        bg={'rentals.states.failed'}
        fontSize={'0.75rem'}
      >
        <Input
          inputMode="numeric"
          size="sm"
          maxW={'160px'}
          autoFocus
          value={value && formatCurrency(Number(value))}
          isInvalid={isInvalid}
          onChange={(e) => setValue(e.target.value.replace(/\D/g, ''))}
          onKeyDown={(e) => {
            if (e.key === 'Enter') confirm();
            if (e.key === 'Escape') setIsEditing(false);
          }}
        />
      </Tooltip>
      <IconButton
        aria-label="Confirmar valor a pagar"
        icon={<IoCheckmark />}
        size="xs"
        isDisabled={isInvalid}
        onClick={confirm}
      />
    </HStack>
  );
};

export default EditableAmount;
